import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "margin-top": "48px"
  }
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "width": "100%",
    "height": "160px"
  }
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  }
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "13px",
    "margin-top": "32px",
    "color": "#bbb"
  }
}, "如果没有自动打开，请手动选择操作", -1);
const _hoisted_5 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "width": "calc(100vw - 72px)"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_empty = _resolveComponent("van-empty");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_empty, null, {
    image: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
      color: "#bbb",
      size: "88px",
      name: "wechat"
    })])]),
    description: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_loading, {
      size: "18px",
      color: "#ccc",
      "text-color": "#999"
    }, {
      default: _withCtx(() => [_createTextVNode("正在打开微信扫一扫..")]),
      _: 1
    })]), _hoisted_4]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_van_button, {
      onClick: $options.backToMiniProgram,
      plain: "",
      round: "",
      block: "",
      color: "#ff9500",
      style: {
        "flex": "1"
      }
    }, {
      default: _withCtx(() => [_createTextVNode("已完成扫码")]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_van_button, {
      onClick: $options.startScan,
      round: "",
      block: "",
      color: "#ff9500",
      style: {
        "flex": "1",
        "margin-left": "16px"
      }
    }, {
      default: _withCtx(() => [_createTextVNode("微信扫一扫")]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  })]);
}